<template>
  <div class="page">
    <section class="main-wrap">
      <div class="main-cont clear">
        <div class="main-header">
          <div class="main-h-l">
            <a href="javascript:void(0);" title="返回首页"><img src="../../assets/images/login/wz_logo_c.png" /></a><span>帐号注册</span>
          </div>
          <a href="javascript:void(0);" @click="returnIndex" class="main-h-r">回首页看看</a>
        </div>
        <div class="main-form clear">
          <div class="main-f-tit">注册</div>
          <form action="#">
            <div class="main-f-input">
              <label><input type="text" v-model="phone" placeholder="请输入您的手机号码" /></label>
            </div>
            <div class="main-f-input login-coder">
              <div class="login-coder-inpt">
                <label><input type="text" v-model="code" placeholder="验证码" /></label>
              </div>
              <div class="login-coder-txt" id="getCode" @click="next(1)">
              </div>
              <div class="main-f-input but">
                <label><input type="button" value="下一步" @click="next(2)" /></label>
              </div>
              <div class="main-pass">
                <em>我有帐号，去<a href="javascript:void(0);" @click="login">登录</a></em>
              </div>
            </div>
          </form>
        </div>
        <div class="copy">
          Copyright © 2017-2021 中润普达 －
          <a href="#" target="_blank">京ICP备2021002262号-1</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import '@/assets/css/login.css'
import { request } from '@/network/request'
import { Message } from 'element-ui'

export default {
  data () {
    return {
      phone: null,
      code: null,
      uuid: null,
    }
  },
  created () {
    this.getCaptchaImage();
  },
  methods: {
    // 返回首页
    returnIndex () {
      this.$router.push('/');
    },
    // 登录
    login () {
      this.$router.push('/login');
    },
    // 获取验证码
    getCaptchaImage () {
      let _this = this;
      request({
        url: '/captchaImage',
        method: 'get'
      }).then(res => {
        if (res.data.code == 200) {
          $("#getCode").empty();
          var codeUrl = 'data:image/gif;base64,' + res.data.img;
          $("#getCode").append('<img src="' + codeUrl + '">');
          _this.uuid = res.data.uuid;
        } else {
          Message('验证码获取失败');
        }
      })
    },
    // 下一步
    next (index) {
      let _this = this;
      if (index == 1) {
        _this.getCaptchaImage();
      } else {
        if (_this.phone == null) {
          Message('请输入手机号');
          return;
        }
        if (_this.code == null) {
          Message('请输入验证码');
          return;
        }
        request({
          url: '/sms',
          method: 'get',
          params: {
            'phone': _this.phone,
            'code': _this.code,
            'uuid': _this.uuid,
          },
        }).then(res => {
          if (res.data.code == 200) {
            this.$router.push({ path: '/registerTwo', query: { phone: _this.phone } });
          } else {
            Message(res.data.msg);
            this.next(1);
          }
        })
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/login/register.vue